import { CategoryBreadcrumbs } from "~/components/kiosk/products/category-breadcrumbs";
import { kioskActions } from "~/stores/kiosk-session/actions";
import { StampcardRewardPopup } from "~/components/kiosk/products/stampcard-reward-popup";
import { StampcardRewardBanner } from "~/components/kiosk/products/stampcard-reward-banner";
import { StampcardCollectBanner } from "~/components/kiosk/products/stampcard-collect-banner";
import { useKioskActiveCategory } from "~/stores/kiosk-session/hooks/use-kiosk-active-category";
import { useKioskProducts } from "~/stores/kiosk-session/hooks/use-kiosk-products";
import { useKioskProductsCategories } from "~/stores/kiosk-session/hooks/use-kiosk-products-categories";
import { useKioskRedeemingSessionStatus } from "~/stores/kiosk-session/hooks/use-kiosk-session";
import { useKioskStore } from "~/routes/__app.kiosk/route";

import { Header } from "./header";
import { Products } from "./products";
import { Footer } from "./footer";

export const KioskProductsPage = () => {
  return (
    <div className="flex h-full flex-col">
      <Header />

      <Categories />

      <StampcardBanner />

      <Products />

      <StampcardPopup />

      <Footer />
    </div>
  );
};

const Categories = () => {
  const categories = useKioskProductsCategories();
  const activeCategory = useKioskActiveCategory();

  return (
    <CategoryBreadcrumbs
      categories={categories}
      activeCategoryId={activeCategory?.id ?? null}
      onCategoryChange={kioskActions.session.setActiveCategoryId}
    />
  );
};

const StampcardPopup = () => {
  const { productsRedeemable } = useKioskProducts();
  const redeemingSessionStatus = useKioskRedeemingSessionStatus();

  if (productsRedeemable.length > 0 && redeemingSessionStatus === "idle") {
    return (
      <div className="px-8 py-4">
        <StampcardRewardPopup
          onRedeem={() => {
            kioskActions.session.setRedeemingSessionStatus("active");
          }}
          onClose={() => {
            kioskActions.session.setRedeemingSessionStatus("inactive");
          }}
        />
      </div>
    );
  }

  return null;
};

const StampcardBanner = () => {
  const user = useKioskStore((state) => state.user);

  const { productsList, productsRedeemable } = useKioskProducts();
  const redeemingSessionStatus = useKioskRedeemingSessionStatus();

  const hasStampProducts = productsList.some(
    ({ product }) => (product.stamps ?? 0) > 0
  );

  if (redeemingSessionStatus === "active" && productsRedeemable.length > 0) {
    return (
      <div className="px-8 py-4">
        <StampcardRewardBanner />
      </div>
    );
  }

  if (productsRedeemable.length === 0 && user && hasStampProducts) {
    return (
      <div className="px-8 py-4">
        <StampcardCollectBanner />
      </div>
    );
  }

  return null;
};
